// extracted by mini-css-extract-plugin
module.exports = {"container":"_0f2dd18"};